module.exports = __webpack_public_path__ + "media/images/flags/4x3/sdn-e6347c046753873779439779306310a8.svg";